module.exports = __webpack_public_path__ + "static/img/new-line-example.86db586.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new-line-example.png
// module id = 5kgk
// module chunks = 134